module.exports = __webpack_public_path__ + "img/bg1.ab068d9a.png";